import React, { memo } from 'react';
import { Grid, Skeleton } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { VictoryPie } from 'victory';
import useTheme from '@mui/styles/useTheme';
import { useChartStyles } from './hooks/useChartStyles';

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    marginTop: theme.spacing(5),
    width: '100%',
    height: theme.spacing(15),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },
  legendRows: {
    paddingLeft: theme.spacing(1)
  },
  bulletIcon: {
    marginRight: theme.spacing(1),
    height: theme.spacing(1.25),
    width: theme.spacing(1.25),
    backgroundColor: theme.skelton.color
  },
  pieContainer: {
    marginLeft: theme.spacing(0),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0.5),
    height: theme.spacing(25)
  },
  skeleton: {
    backgroundColor: theme.skelton.color,
    width: '60%'
  }
}));

export const LabelChartSkeleton: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const chartStyle = useChartStyles(theme);
  return (
    <Grid container direction="row">
      <Grid
        container
        item
        xs={6}
        justifyContent="center"
        alignContent="center"
        data-testid="label-chart-pie-skeleton-container"
        className={classes.pieContainer}
      >
        <Grid item>
          <VictoryPie
            data={[{ x: 1, y: 1, color: theme.palette.insights.noData }]}
            innerRadius={chartStyle.VictoryChartNoData.innerRadius}
            width={chartStyle.VictoryChartNoData.width}
            labels={() => ''}
            style={{
              data: {
                fill: ({ datum }) => datum.color
              }
            }}
            data-testid="label-chart-pie-skeleton"
          />
        </Grid>
      </Grid>
      <Grid container item xs={6}>
        <div className={classes.legendContainer}>
          {[...Array(3)].map((_i, index) => (
            <Grid
              container
              className={classes.legendRows}
              key={JSON.stringify(index)}
            >
              <Grid
                item
                xs={12}
                container
                alignItems="center"
                data-testid="label-chart-legend-skeleton"
              >
                <Skeleton variant="circular" className={classes.bulletIcon} />
                <Skeleton className={classes.skeleton} />
              </Grid>
            </Grid>
          ))}
        </div>
      </Grid>
    </Grid>
  );
};
export default memo(LabelChartSkeleton);
